import Seo from "../components/Seo.jsx";

function NoPage() {
    return(
        <>
        <Seo noindex title="Page Not Found | Pentagon Properties" />
        <h1>Error 404, No Page Found</h1>
        </>
         
    )
};
export default NoPage
